// src/pages/income/env/total/IncomeEnvTotalDraftList.jsx
// ✅ 환경/종합 "수입목록" 페이지 — 얇은 래퍼.
import React from "react";
import IncomeDraftList from "../../_shared/IncomeDraftList";
import incomeEnvTotalDraftConfig from "./incomeEnvTotalDraftConfig";

export default function IncomeEnvTotalDraftList() {
  return <IncomeDraftList config={incomeEnvTotalDraftConfig} />;
}
